export default "__VITE_PUBLIC_ASSET__700d677b__"